import { dialog } from "nq-component";
import { restUseCase } from "../usecases/rest";
import {
  getHeroContent,
  getFooterContent,
  getProductOptions,
  getContactDetails,
} from "./ContactPageContent";

class ContactPresenter {
  constructor(view) {
    this.view = view;
  }

  //   componentDidMount() {
  //  }

  getHeroSectionContent() {
    return getHeroContent();
  }

  getFooterContent() {
    return getFooterContent();
  }

  getProductOptions() {
    return getProductOptions();
  }

  getContactDetails() {
    return getContactDetails();
  }

  async submit(formData) {
    const method = "POST";
    const path = "/send-email/644ae675-52f2-4103-a72a-0d2174ccb3b2";

    const obj = {
  to: formData.email,
  subject: `Product Inquiry - ${formData.subject}`,
  body: `
    Hi <strong>${formData.firstName}</strong>,<br><br>

    Thank you for contacting us! We’ve received your inquiry and someone from our team will get back to you shortly.<br><br>

    Here’s a quick summary of your message:<br>
     Name: <strong>${formData.firstName} ${formData.lastName}</strong><br>
     Company: <strong>${formData.companyName}</strong><br>
     Business Email: <strong>${formData.email}</strong><br>
     Industry: <strong>${formData.industryType}</strong><br>
     Product Inquiry: <strong><em>${formData.subject}</em></strong><br>
     Message: <em>${formData.message}</em><br><br>

    📞 <strong>If needed, we may also reach you at:</strong> ${formData.contactNumber}<br><br>

    We appreciate your interest and will be in touch as soon as possible.<br>
    In the meantime, feel free to explore more about our products and services at <a href="https://www.tenthcorp.com">https://www.tenthcorp.com</a>.<br><br>

    Best regards,<br>
    <em>The Tenth Corporation Team</em>
  `
};


    console.log("Submitted via presenter:", formData);

    try {
      dialog.fire({
        html: (
          <div className="text-center py-4">
            <i className="bi bi-send fs-1 text-primary mb-3"></i>
            <h5 className="mb-2">Sending Message</h5>
            <p>Please wait while we send your message...</p>
          </div>
        ),
        footer: false,
      });

      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        this.view.closeDialog();
        this.view.showSuccess(
          "Your message has been sent successfully!",
          "Success"
        );
      }
    } catch (error) {
      this.view.closeDialog();
      this.view.showDialog({
        title: "Failed",
        message:
          "Something went wrong while sending your message. Please try again.",
        icon: "bi bi-x-circle",
        type: "danger",
        positiveButton: "OKAY",
      });
    }
  }

  onChange(value, field) {
    try {
      let sanitizedValue = value;

      if (field === "contactNumber") {
        sanitizedValue = value.replace(/\D/g, "").slice(0, 12);
      }

      const updated = {
        ...this.view.state.formData,
        [field]: sanitizedValue,
      };

      this.view.setState({ formData: updated });
    } catch (error) {
      console.error(`Error updating form field "${field}":`, error);
    }
  }
}

export default ContactPresenter;
